import React from 'react'
import SideBar from '@/shared/components/SideBar/SideBar'
import Header from '@/shared/components/Header/Header'

import ChatBot from '@/shared/components/ChatBot/ChatBot'
import styles from '../PageLayout.module.scss'
import CropImageModal from '@/shared/components/Modal/CropImageModal/CropImageModal'
import { SettingsModal } from '@/features/settings'

type PageLayoutProps = {
  children: React.ReactNode
}

function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className={styles.protectedPageLayout}>
      <SideBar />
      <Header />
      {children}
      <ChatBot />
      {/* Before the crop dialog: its profile photo opens that one on top. */}
      <SettingsModal />
      <CropImageModal />
    </div>
  )
}

export default PageLayout
